import React from 'react';
import Journey from '../Journey';
import { LangContext } from '../../contexts/LangContext';
import './LoyaltyPath.css';

export default function LoyaltyPath({ loyaltyData, cartTotalSpend = 0, server, token, username, onClaimSuccess }) {
  const { t, lang } = React.useContext(LangContext);
  const learnMoreUrl = lang === 'USD'
    ? 'https://wydglobal.raidhut.com/en/3455'
    : 'https://wydglobal.raidhut.com/pt-br/3454';
  if (!loyaltyData?.activeEditions?.length) return null;

  const { activeEditions, claimedGoalIds, claimedGoals } = loyaltyData;
  const weekly  = activeEditions.find(e => e.type === 'weekly');
  const monthly = activeEditions.find(e => e.type === 'monthly');
  const lp = t.component.loyaltyPath;

  return (
    <div className="loyalty-path-section">
      <div className="loyalty-path-title">
        <img src="img/arrow-left.png" alt="" className="title-arrow" />
        <span className="title-text">{lp.title.toUpperCase()}</span>
        <img src="img/arrow-right.png" alt="" className="title-arrow" />
      </div>

      <div className="loyalty-path-description">
        <span className="loyalty-path-description-text">{lp.description}</span>
        <span className="loyalty-path-learn-more">
          {lp.learnMore}
          <div className="info-bubble-wrapper">
            <span className="info-bubble">?</span>
            <div className="info-tooltip info-tooltip--right">
              {lp.learnMoreTooltip}
              <a
                href={learnMoreUrl}
                target="_blank"
                rel="noreferrer"
                className="info-tooltip-link"
                onMouseDown={e => e.stopPropagation()}
              >
                {lp.learnMoreTooltipLink}
              </a>
            </div>
          </div>
        </span>
      </div>

      <div className="journeys-row">
        {weekly && (
          <Journey
            edition={weekly}
            claimedGoalIds={claimedGoalIds}
            claimedGoals={claimedGoals}
            cartTotalSpend={cartTotalSpend}
            label={lp.weekly}
            server={server}
            token={token}
            username={username}
            onClaimSuccess={onClaimSuccess}
          />
        )}
        {weekly && monthly && (
          <svg
            className="loyalty-path-divider"
            viewBox="0 0 598 11"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M293.609 5.26577L298.876 -0.0010376L304.145 5.26577L298.876 10.5326L293.609 5.26577ZM305.901 5.26577L309.859 1.30569L312.712 4.15863L575.181 4.71115C590.021 4.82249 595.391 5.06409 597.755 5.26577C595.391 5.46745 590.021 5.70905 575.181 5.82039L312.712 6.37292L309.859 9.22586L305.901 5.26577ZM0 5.26577C2.36135 5.06409 7.7332 4.82249 22.5735 4.71115L285.042 4.15863L287.893 1.30569L291.853 5.26577L287.893 9.22586L285.042 6.37292L22.5735 5.82039C7.7332 5.70905 2.36135 5.46745 0 5.26577Z"
              fill="#F4AB32"
            />
          </svg>
        )}
        {monthly && (
          <Journey
            edition={monthly}
            claimedGoalIds={claimedGoalIds}
            claimedGoals={claimedGoals}
            cartTotalSpend={cartTotalSpend}
            label={lp.monthly}
            server={server}
            token={token}
            username={username}
            onClaimSuccess={onClaimSuccess}
          />
        )}
      </div>
    </div>
  );
}
